
import { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="luxury-gradient sticky top-0 z-50 shadow-luxury">
      <div className="container">
        <div className="flex items-center justify-between py-4">
          {/* Left Side - Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-3">
              <img 
                src="https://static.readdy.ai/image/fe8b515158af0db48733429dc03d6fd6/b385f0b7cf62137aadc7a424be852746.png" 
                alt="Salon Logo" 
                className="w-16 h-16 object-contain"
              />
              <h1 className=" text-white md:text-3xl text-primary-400 text-shadow-luxury">
                Fully A/C Salon
              </h1>
            </Link>
          </div>

          {/* Center Navigation */}
          <nav className="hidden lg:flex items-center space-x-6">
            <Link to="/" className="text-white hover:text-primary-400 transition-colors duration-300 font-medium">
              Home
            </Link>
            <Link to="/about" className="text-white hover:text-primary-400 transition-colors duration-300 font-medium">
              About
            </Link>
            <Link to="/services" className="text-white hover:text-primary-400 transition-colors duration-300 font-medium">
              Services
            </Link>
            <Link to="/gallery" className="text-white hover:text-primary-400 transition-colors duration-300 font-medium">
              Gallery
            </Link>
            <Link to="/contact" className="text-white hover:text-primary-400 transition-colors duration-300 font-medium">
              Contact
            </Link>
          </nav>

          {/* Right Side - Booking Button */}
          <div className="hidden lg:flex items-center space-x-4">
            <Link
              to="/booking"
              className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-full font-semibold transition-all duration-300 btn-hover-effect flex items-center space-x-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-line"></i>
              <span>Book Now</span>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="lg:hidden text-white hover:text-primary-400 transition-colors duration-300 cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-700">
            <nav className="flex flex-col space-y-4">
              <Link
                to="/"
                className="text-white hover:text-primary-400 transition-colors duration-300 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link
                to="/about"
                className="text-white hover:text-primary-400 transition-colors duration-300 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                About
              </Link>
              <Link
                to="/services"
                className="text-white hover:text-primary-400 transition-colors duration-300 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Services
              </Link>
              <Link
                to="/booking"
                className="text-white hover:text-primary-400 transition-colors duration-300 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Booking
              </Link>
              <Link
                to="/gallery"
                className="text-white hover:text-primary-400 transition-colors duration-300 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Gallery
              </Link>
              <Link
                to="/contact"
                className="text-white hover:text-primary-400 transition-colors duration-300 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Contact
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
